import React, { useEffect, } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import FadeIn from "../common/FadeIn";
//Analytics
import TagManager from "react-gtm-module";

const Success = () => {
  // Get the Venue Details and set them.
  useEffect( () => {
    return TagManager.dataLayer({
      dataLayer: {
        'event':"checkoutSuccess",
      },
    });
  }, []);

  return (
    <FadeIn delay={250} duration={450}>
    <Container className="pt-5 pb-5">
      <Row>
        <Col>
        <div className='shadow p-4 loginForm mx-auto'>
          <h1>
            Success! It may take a moment for changes to be processed
            and show in your dashboard.
          </h1>
          <Button as={Link} to={`/dashboard/`} variant="primary" className="mt-3 mb-3">Dashboard</Button>
          </div>
        </Col>
      </Row>
    </Container>
  </FadeIn>
  )
}
//export the component
export default Success;
